import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useFetchDashboardIsuueDetailsQuery, useFetchDashboardTodaysTaskQuery,} from "../../slice/logdetailSlice";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import { useSelector } from "react-redux";
import { CustomNoRowsOverlay } from "../common/OverlayGrid";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import { TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CustomTasksCalender } from "../../pages/taskallocation/CustomTasksCalender";
import { MdOutlineAccessTime } from "react-icons/md";
// import TodaysTaskSummaryDetails from "./TodaysTaskSummaryDetails";
import { Offcanvas, OffcanvasBody } from "react-bootstrap";
import StaffInfoCard from "../../pages/taskallocation/StaffInfoCard";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";


const TodaysTask = () => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [tableRows, setTableRows] = useState({});
  const [showSummary, setShowSummary] = useState(false);
  const { control } = useForm();
  const navigate = useNavigate();
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // const { role: login_user_role } = login_user;
  const { role: login_user_role } = login_user || {};
  const { isLoading: issue_loading, } = useFetchDashboardIsuueDetailsQuery();
  const { data = [], refetch: todays_refetch } = useFetchDashboardTodaysTaskQuery({
      //   date: "2025-07-01",
      date: dayjs(selectionRange.startDate).format("YYYY-MM-DD"),
    });
  //   console.log("todays_data :", data);
  useEffect(() => {
    todays_refetch();
  }, [selectionRange]);

  const handleNvaigateTimesheet = (project_id) => {
    navigate(`/projects/projectDetail/${project_id}/timesheet`);
    const rangeObject = {
      startDate: selectionRange.startDate.toISOString(),
      endDate: selectionRange.startDate.toISOString(),
      key: "selection",
    };
    // console.log("range_object", rangeObject);

    localStorage.setItem("timesheetProjectSpan", "today");
    localStorage.setItem("timesheetDateRange", JSON.stringify(rangeObject));
  };

  const onCloseSummary = () => {
    setShowSummary(!showSummary);
  };

  const handleRowClick = (params) => {
    console.log("row_list", params.row);
    setTableRows(params.row);
  };

  const renderTaskListCell = (params) => {
    const value = params.row.task_list;
    console.log("params_value :", params.row.task_list);

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <TextField
          multiline
          placeholder="Enter description"
          minRows={2}
          defaultValue={value}
          // onKeyDown={(e) => e.stopPropagation()}
          variant="standard"
          fullWidth
          InputProps={{
            disableUnderline: true,
            readOnly: true,
            sx: {
              fontSize: 13,
              // backgroundColor: "#F6F6F6",
              padding: "6px 12px",
              borderRadius: "8px",
              width: "100%",
              whiteSpace: "pre-wrap",
              textAlign: "justify",
            },
          }}
          sx={{
            textarea: {
              resize: "none",
              textAlign: "justify",
            },
          }}
        />
      </Box>
    );
  };

  const columns = [
    {
      field: "project_name",
      headerName: "Project",
      minWidth: 300,
      flex: 1,
      renderCell: (params) => {
        let styles = {};
        const name = params.row.project?.title || "-";
        const work_status = params.row.work_status || "-";
        switch (work_status) {
          case "BENCH":
            styles = {
              backgroundColor: "#f8d7da",
              color: "#a31616",
              borderColor: "#f5c6cb",
            };
            break;
          case "ENGAGED":
            styles = {
              backgroundColor: "#d1ecf1",
              color: "#0c5460",
              borderColor: "#bee5eb",
            };
            break;
          case "SHORTLY_AVAILABLE":
            styles = {
              backgroundColor: "#e2d6f6",
              color: "#6f42c1",
              borderColor: "#c8b6e2",
            };
            break;
          case "LONG_TERM":
            styles = {
              backgroundColor: "#e2f0cb",
              color: "#4b7902",
              borderColor: "#c8e6b8",
            };
            break;
          default:
            styles = {
              backgroundColor: "var(--cell-bg-color)",
              color: "var(--text-color)",
              borderColor: "var(--border-color)",
            };
        }

        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center", // ✅ vertical center
              alignItems: "flex-start", // ✅ left align (x start)
              width: "100%",
              height: "100%",
              padding: 2,
            }}
          >
            <Typography
              sx={{
                cursor: "pointer",
                fontWeight: "bold", // corrected
              }}
              onClick={() => {
                // navigate(`/projects/projectDetail/${params.row.project.project_id}/details`)
                if (params.row.project?.project_id) {
                  navigate(
                    `/projects/projectDetail/${params.row.project.project_id}/details`
                  );
                }
              }}
            >
              {name}
            </Typography>

            <Box display="flex" alignItems="center" gap={1}>
              <Typography
                sx={{
                  fontSize: 12,
                  color: styles.color,
                  fontWeight: 500,
                }}
              >
                {work_status.replace("_", " ")}
              </Typography>
              <MdOutlineAccessTime
                onClick={() => {
                  // handleNvaigateTimesheet(params.row.project.project_id)
                  if (params.row.project?.project_id) {
                    handleNvaigateTimesheet(params.row.project.project_id);
                  }
                }}
                style={{
                  fontSize: "16px",
                  color: "#1976d2",
                  cursor: "pointer",
                }}
              />
            </Box>
          </Box>
        );
      },
    },

    {
      field: "task_list",
      headerName: "Task List",
      minWidth: 250,
      flex: 1,
      renderCell: renderTaskListCell,
      editable: false,
    },

    {
      field: "work_hours",
      headerName: "Work Hours",
      width: 100,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {params.value}
        </Box>
      ),
    },

    {
      field: "project_manager",
      headerName: "Project Manager",
      width: 200,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {params.row.project_manager?.name || "-"}
        </Box>
      ),
      // renderCell: (params) => params.row.project_manager?.name || "-",
    },

    {
      field: "work_till",
      headerName: " Work Till",
      width: 160,
      renderCell: (params) => {
        const Date = dayjs(params.value).format("DD/MM/YYYY");
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {Date || "-"}
          </Box>
        );
      },
    },

    {
      field: "other_details",
      headerName: "Other Details",
      width: 160,
      renderCell: (params) => {
        return (
          <Box
            // onClick={onCloseSummary}
               onClick={() => {
              setTableRows(params.row);
              onCloseSummary();
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              cursor: "pointer",
            }}
          >
            <MoreHorizIcon />
          </Box>
        );
      },
    },
  ];

  return (
    <>
      {issue_loading ? (
        <Loader />
      ) : (
        <div>
          <Offcanvas
            placement="end"
            show={showSummary}
            style={{ width: "30%" }}
          >
            <OffcanvasBody>
              <StaffInfoCard
                onClose={onCloseSummary}
                staff={tableRows}
                isDasboard={true}
              />
            </OffcanvasBody>
          </Offcanvas>
          
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="bg-white p-3 rounded-3">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  <h5 className="cardsub_title mb-0 pe-3">
                    {login_user_role === "ADMIN" || login_user_role === "CLIENT"
                      ? "Today's Task"
                      : "Today's Task"}
                  </h5>
                  <div className="cardsub_title_line"></div>
                </div>
                <div>
                  <CustomTasksCalender
                    selectionRange={selectionRange}
                    setSelectionRange={(range) => setSelectionRange(range)}
                  />
                </div>
              </div>

              <div style={{ width: "100%" }} className="tableScroll">
                <DataGrid
                  rows={data || []}
                  columns={columns}
                  rowHeight={70}
                  getRowHeight={() => "auto"}
                  getRowId={(row) => `${row?.task_allocation_id}`}
                  pagination
                  paginationModel={paginationModel}
                  slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                  onPaginationModelChange={setPaginationModel}
                  onRowClick={handleRowClick}
                  pageSizeOptions={[10, 25, 50, 100]}
                  sx={{
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#f5f5f5",
                      fontWeight: "bold",
                    },
                    "& .MuiDataGrid-cell[data-field='task_list']": {
                      whiteSpace: "normal !important",
                      wordWrap: "break-word !important",
                      alignItems: "flex-start",
                    },
                  }}
                />
              </div>
            </div>
          </LocalizationProvider>
        </div>
      )}
    </>
  );
};

export default TodaysTask;
